import { RegisterForm } from '@/features/auth/RegisterForm'

export function RegisterPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-canvas p-4">
      <RegisterForm />
    </main>
  )
}
